module.exports = __webpack_public_path__ + "static/media/gia.e6945d24.png";